import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { BookOpen, MessageSquare, FileText } from 'lucide-react';
const enfoques = ['Psicología Sistémica y Transpersonal', 'Biodecodificación (Bioneuroemoción)', 'Constelaciones Familiares en sesión individual', 'Registros Akáshicos y Memoria Cuántica', 'Epigenética Conductual y Neurobiología del Trauma', 'Somatic Healing (Sanación Corporal)'];
export const SystemOverview = () => {
  return <section className="py-24 bg-cream relative" data-id="element-270">
      <div className="container mx-auto px-6" data-id="element-271">
        <SectionHeading title="EL SISTEMA N°1 EN INTEGRACIÓN CLÍNICA" subtitle="Método Completo · 5 Módulos + 3 Súper Bonos VIP · Riguroso y Práctico · Todo Resuelto" data-id="element-272" />

        <div className="grid md:grid-cols-3 gap-8 mb-16 max-w-5xl mx-auto" data-id="element-273">
          {[{
          icon: BookOpen,
          text: '+350 páginas de contenido técnico estructurado.'
        }, {
          icon: MessageSquare,
          text: 'Guiones verbatim (palabra por palabra) para consulta.'
        }, {
          icon: FileText,
          text: 'Fichas clínicas de diagnóstico y consentimiento informado.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col items-center text-center p-6 bg-cream-100 rounded-sm border border-gold-500/20" data-id="element-274">
              <item.icon className="w-10 h-10 text-gold-500 mb-4" data-id="element-275" />
              <p className="font-serif text-lg text-navy font-medium" data-id="element-276">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-277">
          <h3 className="font-serif text-2xl mb-8 text-navy" data-id="element-278">
            Enfoques que integrarás con éxito en 30 días:
          </h3>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-279">
            {enfoques.map((enfoque, i) => <motion.span key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className="px-4 py-2 bg-navy text-cream rounded-full text-sm font-medium border border-gold-500/30 shadow-sm" data-id="element-280">
                {enfoque}
              </motion.span>)}
          </div>
        </div>
      </div>
    </section>;
};